import { workflowComponent } from '@banking/ui/services/debit-card-activation-modal';
import { userChangeEmailConfirmationCodeAction, userClickVerifyActivationTokenAction, userClickResendActivationTokenAction } from '@banking/ui/workflows/debit-card-activation';
import { hbs } from 'ember-cli-htmlbars';
const template = hbs`
  <Banking::Checking::CardSettings::CardActivation::Email
    @confirmationCode={{this.emailConfirmationCode}}
    @emailConfirmationErrorMessage={{this.emailConfirmationErrorMessage}}
    @verifyConfirmationCode={{this.verifyConfirmationCode}}
    @isLoading={{this.isLoading}}
    @onConfirmationCodeChange={{this.onEmailConfirmationCodeChange}}
    @sendConfirmationCode={{this.sendConfirmationCode}}
  />`;
const mapStateToProps = state => ({
  emailConfirmationCode: state.emailConfirmationCode,
  emailConfirmationErrorMessage: state.emailConfirmationErrorMessage || null,
  isLoading: state.isLoading
});
const mapActionsToProps = () => ({
  sendConfirmationCode: userClickResendActivationTokenAction,
  verifyConfirmationCode: userClickVerifyActivationTokenAction,
  onEmailConfirmationCodeChange: userChangeEmailConfirmationCodeAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);